import React from "react";
import "./completeCover.style.scss";


export default function CompleteCover(props) {

  return (
    <div className='tmex-verification-complete-cover'>
    </div>
  );
}
